import BackofficeUsersList from './views/BackofficeUserList'
import BackofficeUserEdit from './views/BackofficeUserEdit'
import BackofficeUserCreate from './views/BackofficeUserCreate'

export default {
  name:"backofficeUsers",
  list:BackofficeUsersList,
  edit:BackofficeUserEdit,
  create:BackofficeUserCreate,
}